module.exports = __webpack_public_path__ + "img/winery.74f68a83.jpg";